export var ErrorCode;
(function (ErrorCode) {
    ErrorCode["RegistrationSessionExpired"] = "0001";
    ErrorCode["AlreadyRegistered"] = "0002";
    ErrorCode["ReferenceMustBeUnique"] = "2002";
    ErrorCode["RegistrationTimeout"] = "0003";
    ErrorCode["ActiveAccountNotFound"] = "0004";
    ErrorCode["PaymentSessionNotFound"] = "0005";
    ErrorCode["PaymentSessionExpired"] = "0006";
    ErrorCode["DuplicatePaymentSession"] = "0007";
    ErrorCode["RegistrationNotFound"] = "0008";
    ErrorCode["DuplicatePaymentRequest"] = "0009";
    ErrorCode["TooManyPspAuthorizationAttempts"] = "0010";
    ErrorCode["PaymentAmountTooLow"] = "0011";
    ErrorCode["CheckingAccountNotFound"] = "0012";
    ErrorCode["ACHValidationFailed"] = "0013";
    ErrorCode["MerchantAccountNotFound"] = "0014";
    ErrorCode["MerchantGroupNotFound"] = "0015";
    ErrorCode["HppSubdomainAlreadyExists"] = "0016";
    ErrorCode["BankAccountNotValid"] = "0017";
    ErrorCode["MerchantAccountHasPayments"] = "0018";
    ErrorCode["MerchantAccountNotActive"] = "0019";
    // todo: clean up a ton of these FE-only error codes once HPPv1 is sunsetted
    ErrorCode["PaymentFlowSessionIdMissing"] = "0020";
    ErrorCode["PaymentFlowSessionFailedUnknown"] = "0021";
    ErrorCode["PaymentFlowSessionErrorUnknown"] = "0022";
    ErrorCode["AgencyDetailsMissing"] = "0023";
    ErrorCode["FetchAgencyEmptyResponse"] = "0024";
    ErrorCode["FetchAgencyFailed"] = "0025";
    ErrorCode["FetchAgencyDetailFailedUnknown"] = "0026";
    ErrorCode["GetHPPSessionEmptyResponse"] = "0027";
    ErrorCode["GetHPPSessionFailedTokenMissing"] = "0028";
    ErrorCode["GetHPPSessionFailedUnknown"] = "0029";
    ErrorCode["GetHPPSessionErrorUnknown"] = "0030";
    ErrorCode["DuplicateCompletePaymentAttempt"] = "0031";
    ErrorCode["CreditValidationFailed"] = "0032";
    ErrorCode["ACHRefundInvalidAge"] = "0033";
    ErrorCode["PaymentFlowSessionFailedNetwork"] = "0034";
    ErrorCode["PaymentFlowSessionFailedInternal"] = "0035";
    ErrorCode["FetchAgencyDetailFailedNetwork"] = "0036";
    ErrorCode["FetchAgencyDetailFailedInternal"] = "0037";
    ErrorCode["GetHPPSessionFailedNetwork"] = "0038";
    ErrorCode["GetHPPSessionFailedInternal"] = "0039";
    ErrorCode["InvalidTenantId"] = "0040";
    ErrorCode["EFTValidationFailed"] = "0041";
    ErrorCode["EFTRefundInvalidAge"] = "0042";
    ErrorCode["FieldValidationFailed"] = "1000";
    ErrorCode["ValidationHandlerNotSet"] = "1001";
    ErrorCode["InitAdyenCheckoutFailed"] = "1002";
    ErrorCode["PSPSessionUpdateFailed"] = "1003";
    ErrorCode["PSPSessionUpdateFailedNetwork"] = "1004";
    ErrorCode["PSPSessionUpdateFailedUnknown"] = "1005";
    ErrorCode["TokenExpired"] = "0100";
    ErrorCode["MissingAuthToken"] = "0101";
    ErrorCode["InvalidToken"] = "0102";
    ErrorCode["AuthorizationError"] = "0103";
    ErrorCode["RecaptchaVerificationFailed"] = "2001";
    ErrorCode["RecaptchaBrowserError"] = "2003";
    ErrorCode["GroupAlreadyExists"] = "3001";
    ErrorCode["NotificationNotFound"] = "4001";
    ErrorCode["DeleteNotificationNotAllowed"] = "4002";
    ErrorCode["DuplicateEpicStructures"] = "5001";
    ErrorCode["AllStructuresAlreadyAssigned"] = "5002";
    ErrorCode["StructuresAlreadyAssigned"] = "5003";
    ErrorCode["VerificationCodeNotValid"] = "6001";
    ErrorCode["AccountNumberNotValid"] = "6002";
    ErrorCode["TooManyAttempts"] = "6003";
    ErrorCode["RoutingNumberNotValid"] = "6004";
    ErrorCode["RefundInProgress"] = "7001";
    ErrorCode["Unknown"] = "9999";
})(ErrorCode || (ErrorCode = {}));
//# sourceMappingURL=ErrorCode.js.map